var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5408 21L12.5408 17.25L6.54077 21V4.5C6.54077 4.30109 6.61979 4.11032 6.76044 3.96967C6.90109 3.82902 7.09186 3.75 7.29077 3.75H17.7908C17.9897 3.75 18.1804 3.82902 18.3211 3.96967C18.4618 4.11032 18.5408 4.30109 18.5408 4.5V21Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.540771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkSimple);
export default __webpack_public_path__ + "static/media/bookmark-simple.4c85a573652b28221e3262be02e0c195.svg";
export { ForwardRef as ReactComponent };